var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ANZTEXT',{attrs:{"data":_vm.data,"full-width":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }